import { ArticleDate, type CustomPublication } from '@/legacy/components/ArticleDate'
import { Container } from '@/legacy/components/Container'
import { BodyP } from '@/legacy/components/Typography'

import { useBlogArticleCms } from '@/legacy/providers/BlogArticleCmsProvider'

import ReadingTime from '../ReadingTime'
import { VisuallyHidden } from '../VisuallyHidden'

import { DetailsArticleStyles } from './styles'

interface ArticlePublicationDetailsProps {
  category: string
  readingTime?: string
  publicationDetails: CustomPublication
}

const ArticlePublicationDetails = ({
  category,
  publicationDetails,
  readingTime,
}: ArticlePublicationDetailsProps) => {
  const { article } = useBlogArticleCms()

  const builderPublicationDate = article?.createdDate

  return (
    <Container>
      <DetailsArticleStyles>
        <ArticleDate
          builderPublicationDate={builderPublicationDate}
          customPublication={publicationDetails}
        />
        {category && (
          <>
            <BodyP className="et-text-primary" id="category_describedby" aria-hidden>
              {category}
            </BodyP>
            <VisuallyHidden aria-describedby="category_describedby">{`Categoria ${category}`}</VisuallyHidden>
          </>
        )}
        <ReadingTime readingTime={readingTime} hightlightText />
        <BodyP color="dark-high">Texto de: Time Serasa</BodyP>
      </DetailsArticleStyles>
    </Container>
  )
}
export default ArticlePublicationDetails
